angular.module('picmonicng').controller('Learn404Controller', [
  '$scope',
  '$stateParams',
  'Picmonics',
  'UserService',
  function ($scope, $stateParams, Picmonics, UserService) {
    $scope.suggested = $stateParams.suggested;
    $scope.loading = true;

    if (UserService.user.user_id) {
      $scope.related = Picmonics.search({
        query: $stateParams.query,
        page: 1,
        include_ugc: false,
        searchBreadcrumbs: false,
        searchPicmonics: true,
        searchPathways: false,
        searchPlaylists: false,
        sort_by: 'relevance',
        source: '404',
      });

      $scope.related.$promise.finally(function () {
        $scope.loading = false;
        $scope.$emit('endInteraction');
      });
    } else {
      $scope.loading = false;
      $scope.$emit('endInteraction');
    }
  },
]);
